export const QUADRANTS = [
  { id: 'languages-and-frameworks', label: 'Languages & Frameworks' },
  { id: 'tools', label: 'Tools' },
  { id: 'platforms', label: 'Platforms' },
] as const;

export type CategoryId = (typeof QUADRANTS)[number]['id'];

export const findQuadrant = (category?: string) => {
  if (!category) return undefined;
  const normalized = category.trim().toLowerCase();
  return QUADRANTS.find(
    quadrant =>
      quadrant.id.toLowerCase() === normalized ||
      quadrant.label.toLowerCase() === normalized,
  );
};
